import { ReducerRegistry } from 'store';
import {
  DELETE_ACCOUNT,
  DELETE_ACCOUNT_FAILED,
  DELETE_ACCOUNT_SUCCESS,
  FECH_MERCHANT_BANKS,
  FECH_MERCHANT_BANKS_FAILED,
  FECH_MERCHANT_BANKS_SUCESS,
  FECH_SETTLEMENT_TIMES,
  FECH_SETTLEMENT_TIMES_FAILED,
  FECH_SETTLEMENT_TIMES_SUCESS,
  UPDATE_ASYNC_START,
  UPDATE_PRIMARY_ACCOUNT,
  UPDATE_PRIMARY_ACCOUNT_FAILED,
  UPDATE_PRIMARY_ACCOUNT_SUCCESS,
  USER_PROFILE,
  FETCH_BANK_DETAILS,
} from '../types';

const INIT_STATE = {
  profile: {},
  inProgress: false,

  merchantBanks: {
    merchantBanksStatus: false,
    inProgress: false,
    banks: [],
  },

  settlementTimes: {
    settlementStatus: false,
    inProgress: false,
    times: {},
  },

  bankDetails: [],
};

export const settingsReducer = ReducerRegistry.register(
  'settings',
  (state = INIT_STATE, { type, payload }) => {
    switch (type) {
      case UPDATE_ASYNC_START:
        return {
          ...state,
          inProgress: true,
        };
      case USER_PROFILE:
        return {
          ...state,
          profile: payload,
          inProgress: false,
        };
      case FECH_MERCHANT_BANKS:
        return {
          ...state,
          merchantBanks: {
            ...state.merchantBanks,

            inProgress: true,
          },
        };
      case FECH_MERCHANT_BANKS_SUCESS:
        return {
          ...state,
          merchantBanks: {
            ...state.merchantBanks,
            banks: payload,
            inProgress: false,
            merchantBanksStatus: payload.length > 0,
          },
        };
      case FECH_MERCHANT_BANKS_FAILED:
        return {
          ...state,
          merchantBanks: {
            ...state.merchantBanks,
            inProgress: false,
          },
        };

      case UPDATE_PRIMARY_ACCOUNT:
        return {
          ...state,
          merchantBanks: {
            ...state.merchantBanks,
            inProgress: true,
          },
        };
      case UPDATE_PRIMARY_ACCOUNT_SUCCESS:
        return {
          ...state,
          merchantBanks: {
            ...state.merchantBanks,
            inProgress: false,
          },
        };
      case UPDATE_PRIMARY_ACCOUNT_FAILED:
        return {
          ...state,
          merchantBanks: {
            ...state.merchantBanks,
            inProgress: false,
          },
        };
      case DELETE_ACCOUNT:
        return {
          ...state,
          merchantBanks: {
            ...state.merchantBanks,
            inProgress: true,
          },
        };
      case DELETE_ACCOUNT_SUCCESS:
        return {
          ...state,
          merchantBanks: {
            ...state.merchantBanks,
            inProgress: false,
          },
        };
      case DELETE_ACCOUNT_FAILED:
        return {
          ...state,
          merchantBanks: {
            ...state.merchantBanks,
            inProgress: false,
          },
        };
      case FECH_SETTLEMENT_TIMES:
        return {
          ...state,
          settlementTimes: {
            ...state.settlementTimes,
            inProgress: true,
          },
        };
      case FECH_SETTLEMENT_TIMES_SUCESS:
        return {
          ...state,
          settlementTimes: {
            ...state.settlementTimes,
            inProgress: false,
            times: payload,
            settlementStatus: !!payload?.settlementPeriod,
          },
        };
      case FECH_SETTLEMENT_TIMES_FAILED:
        return {
          ...state,
          settlementTimes: {
            ...state.settlementTimes,
            inProgress: false,
          },
        };
      case FETCH_BANK_DETAILS:
        return {
          ...state,
          bankDetails: payload,
        };

      default:
        return state;
    }
  },
);
